export const stopClickPropagation = (e) => e?.stopPropagation();
